const environments = {
  localhost: {
    REACT_APP_MGA_BACKEND_API_URL:
      "https://appser-mg-mga-backendservices-int.azurewebsites.net/",
    REACT_APP_EMB_BACKEND_API_URL:
      "https://appser-mg-emb-ws-dev.azurewebsites.net/emb/",
    REACT_APP_USER_MGT_API_URL:
      "https://appser-mg-usermanagement-dev.azurewebsites.net",
    REACT_SIMULATION_BACKEND_API_URL: "https://appser-mg-mga-backendservices-int.azurewebsites.net/",
    REACT_APP_VERSION: "2.3",
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "hZanqPkue8PPIGz2H1fT5zn9zAgzqoeV",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_ENABLE_LNG: true,
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    ASHRAE_START_DATE: "2019-01-01T00:00:00.000Z",
  },
  validation: {
    REACT_APP_MGA_BACKEND_API_URL:
      "https://appser-mg-mga-backendservices-val.azurewebsites.net",
    REACT_APP_EMB_BACKEND_API_URL:
      "https://appser-mg-emb-ws-val.azurewebsites.net/emb/",
    REACT_APP_USER_MGT_API_URL:
      "https://appser-mg-usermanagement-val.azurewebsites.net",
    REACT_SIMULATION_BACKEND_API_URL: "https://appser-mg-mga-backendservices-val.azurewebsites.net",
    REACT_APP_VERSION: "2.3",
    REACT_APP_ENABLE_LNG: true,
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "LofeMhcfJP3Qi225jOCcLudKCOfaT39f",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    ASHRAE_START_DATE: "2019-01-01T00:00:00.000Z",
  },
  pprd: {
    REACT_APP_MGA_BACKEND_API_URL:
      "https://preproduction.ecostruxure-microgrid-assessment.se.app",
    REACT_APP_EMB_BACKEND_API_URL:
      "https://appser-mg-emb-ws-cto-pprd.azurewebsites.net/emb/",
    REACT_APP_USER_MGT_API_URL:
      "https://preproduction.ecostruxure-microgrid-assessment.se.app",
    REACT_SIMULATION_BACKEND_API_URL: "https://preproduction.ecostruxure-microgrid-assessment.se.app",
    REACT_APP_VERSION: "2.3",
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "9qQbXrSEwfgMe9CaES0yFyx1BZ8hPscz",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    REACT_APP_ENABLE_LNG: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    ASHRAE_START_DATE: "2019-01-01T00:00:00.000Z",
  },
  pentest: {
    REACT_APP_MGA_BACKEND_API_URL:
      "https://appser-mg-mga-backendservices-pentest-c2a7a9cddzhpcnce.eastus2-01.azurewebsites.net",
    REACT_APP_EMB_BACKEND_API_URL:
      "https://appser-mg-emb-ws-cto-pprd.azurewebsites.net/emb/",
    REACT_APP_USER_MGT_API_URL:
      "https://appser-mg-usermanagement-pentest.azurewebsites.net",
    REACT_SIMULATION_BACKEND_API_URL: "https://appser-mg-mga-backendservices-pentest-c2a7a9cddzhpcnce.eastus2-01.azurewebsites.net",
    REACT_APP_VERSION: "2.3",
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "AthDBcyalfwYYahkateGzvyWMqi1na1C",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    REACT_APP_ENABLE_LNG: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    ASHRAE_START_DATE: "2019-01-01T00:00:00.000Z",
  },
  prod: {
    REACT_APP_MGA_BACKEND_API_URL:
      "https://ecostruxure-microgrid-assessment.se.app",
    REACT_APP_EMB_BACKEND_API_URL:
      "https://appser-mg-emb-ws-cto-pprd.azurewebsites.net/emb/",
    REACT_APP_USER_MGT_API_URL:
      "https://ecostruxure-microgrid-assessment.se.app",
    REACT_SIMULATION_BACKEND_API_URL: "https://ecostruxure-microgrid-assessment.se.app",
    REACT_APP_VERSION: "2.3",
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "zneAxqNahI9X2ptEUbLFZBROq19t5BdO",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    REACT_APP_ENABLE_LNG: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    ASHRAE_START_DATE: "2019-01-01T00:00:00.000Z",
  },
};

const hostname = window.location.hostname;

let currentEnv = environments.production; // Default to production

if (
  hostname.includes("localhost") ||
  hostname.includes("appser-mg-emb-se-int") ||
  hostname.includes("appser-mg-mga-se-dev") ||
  hostname.includes("appser-mg-mga-se-dev")
) {
  currentEnv = environments.localhost;
} else if (hostname.includes("appser-mg-mga-se-val")) {
  currentEnv = environments.validation;
} else if (
  hostname.includes("preproduction.ecostruxure-microgrid-assessment") ||
  hostname.includes("appser-mg-mga-se-pprd-001.azurewebsites.net")
) {
  currentEnv = environments.pprd;
} else if (hostname.includes("appser-mg-mga-se-pentest")) {
  currentEnv = environments.pentest;
} else if(hostname.includes("appser-mg-mga-se-prod") || hostname.includes("ecostruxure-microgrid-assessment")){
  currentEnv = environments.prod;
}

export default currentEnv;
